<template>
    <BasePage :loading="loading" :error="error" :params="params" style="overflow: hidden">
        <SotHeader v-show="params.back_button_visible !== '0'" :label="title" @back="backClick" />

        <q-tab-panels v-model="tab" class="sot-page2 fit" animated v-if="!loading">
            <q-tab-panel name="info" class="no-padding2" style="margin-top: 0px; padding-left: 0; padding-right: 0">
                <div v-if="course" class="base-page-content" style="padding-top: 30px; padding-bottom: 10px">
                    <div v-show="course.image_url" style="margin-top: -20px; padding-bottom: 15px">
                        <q-img :src="course.image_url" fit="cover" style="width: 100%" />
                    </div>

                    <div class="q-gutter-y-lg" style="margin-bottom: 0; padding: 0 15px 0 15px">
                        <div v-if="youtubeVideoUrl || preloadingVideo" style="height: 200px;">
                            <div v-show="preloadingVideo" class="flex flex-center full-height">
                                <q-circular-progress indeterminate size="sm" color="primary" />
                            </div>
                            <q-video
                                v-if="youtubeVideoUrl"
                                :src="youtubeVideoUrl"
                                style="border-radius: 12px"
                                :ratio="16/9"
                            />
                        </div>
                        <div v-show="redirectsLoading" class="flex flex-center">
                            <q-circular-progress indeterminate color="primary" size="sm" />
                        </div>
                        <div>
                            <div class="text-weight-bold">{{ course.title }}</div>
                            <div class="text-caption">{{ course.author }}</div>
                        </div>
                        <div class="text-subtitle1" v-html="course.adv_text" />
                        <div>Описание</div>
                        <div v-html="course.short_description" />
                        <div>Вы научитесь</div>
                        <div class="column q-gutter-y-xs">
                            <div v-html="course.you_will_learn" />
                        </div>

                        <div>Этот курс подойдёт</div>
                        <div class="column q-gutter-y-xs">
                            <div v-html="course.suitable_for" />
                        </div>
                        <div>Преимущества курса</div>
                        <div class="column q-gutter-y-xs">
                            <div v-html="course.benefits" />
                        </div>
                        <div>Преподаватели курса</div>
                        <div class="column q-gutter-y-xs">
                            <div v-html="course.teachers" />
                        </div>
                        <div v-if="!hasBought" v-show="loadingPrice">
                            <div class="text-caption">Стоимость курса</div>
                            <q-circular-progress indeterminate color="primary" size="sm" />
                        </div>
                        <div v-if="hasBought && subscription" v-show="!loadingPrice">
                            <div>Данный курс входит в подписку</div>
                            <div class="text-weight-bold">{{ subscription.title }}</div>
                        </div>
                        <div v-if="hasBought && !subscription && !isFreeCourse" v-show="!loadingPrice">
                            <div>Вы купили этот курс</div>
                            <div class="text-weight-bold">{{ hasBought.title }}</div>
                        </div>

                        <div v-if="!hasBought" v-show="!loadingPrice">
                            <DefaultButton label="Купить курс" class="col" @click="buyCourse" />
                        </div>
                        <div v-if="course" v-show="course.button_visible === '1' && course.button_title && course.button_url">
                            <DefaultButton :label="course.button_title" class="col" @click="openUrl(course.button_url)" />
                        </div>
                        <!--
                        <DefaultButton label="Начать курс" class="col" @click="start" :loading="starting" />
                        -->
                    </div>
                </div>
            </q-tab-panel>
            <q-tab-panel name="tasks" class="overflow-hidden no-margin2 no-padding">
                <PageTasks v-if="tasksParams && !hasModules" :params="tasksParams" style="padding-bottom: 0px;" />
                <PageModules v-if="tasksParams && hasModules" :params="tasksParams" style="padding-bottom: 0px;" />
            </q-tab-panel>
            <q-tab-panel name="certificate" class="overflow-hidden no-margin no-padding2 text-subtitle1">
                <div class="q-gutter-y-md column fit" style="margin-top: 60px; padding: 10px;">
                    <div class="col column flex-center" style="margin-bottom: 0px;">
                        <q-img src="~assets/ui/icons/supergirl.svg" style="max-width: 90%" fit="contain" />
                        <!--
                        <q-img v-if="!buttonCertificateVisible" src="~assets/bee-neutral.svg" style="max-width: 90%" fit="contain" />
                        <q-img v-if="buttonCertificateVisible" src="~assets/bee-positive.webp" style="max-width: 90%" fit="contain" />
                        -->
                    </div>
                    <div class="col-auto" v-if="activeCourse">Набрано звезд: {{ stars }} <q-img src="~assets/ui/sot-star.svg" style="width: 22px; margin-top: -5px" fit="contain" /></div>
                    <div class="col-auto" v-if="!buttonCertificateVisible">Для получения удостоверения необходимо набрать не менее {{ course.min_stars_for_certificate }} звезд.</div>
                    <div class="col-auto" v-if="buttonCertificateVisible">Поздравляем! Вы набрали достаточное количество звёзд для получения удостоверения.</div>
                    <div class="col column flex-center" style="max-height: 120px; margin-bottom: 30px;">
                        <DefaultButton class="col-auto full-width" v-if="buttonCertificateVisible" label="Удостоверение" @click="makeCert" />
                    </div>
                </div>
            </q-tab-panel>
        </q-tab-panels>
        <q-space />
        <div v-if="!loading">
            <q-tabs v-model="tab" align="justify" no-caps dense class="text-caption" switch-indicator indicator-color="primary">
                <!--<q-tab name="info" icon="feed" label="О курсе" style="width: 90px;" />-->
                <q-tab name="info" style="width: 90px;">
                    <div>
                        <q-img src="~assets/ui/icons/about-course.svg" style="width: 15px; padding-bottom: 3px" fit="contain" />
                    </div>
                    <div>О курсе</div>
                </q-tab>
                <q-tab name="tasks" style="width: 90px;">
                    <div>
                        <q-img src="~assets/ui/icons/themes.svg" style="width: 15px; padding-bottom: 3px" fit="contain" />
                    </div>
                    <div>Темы</div>
                </q-tab>
                <q-tab name="certificate" style="width: 90px;" v-show="showResultsButton">
                    <div>
                        <q-img src="~assets/ui/icons/results.svg" style="width: 15px; padding-bottom: 3px" fit="contain" />
                    </div>
                    <div>Результат</div>
                </q-tab>
            </q-tabs>
        </div>
    </BasePage>
</template>

<script>
import BasePage from 'pages/BasePage';
import { api, queryBot } from 'boot/axios';
import SotHeader from 'components/ui/design/SotHeader';
import PageTasks from 'pages/default/PageTasks';
import DefaultButton from 'components/ui/common/DefaultButton';
import PageModules from 'pages/default/PageModules';

const extractUrls = require('extract-urls');

export default {
    name: 'PageCourse',
    components: {
        PageModules,
        DefaultButton,
        PageTasks,
        SotHeader,
        BasePage,
    },
    props: {
        params: {
            type: Object,
            default: undefined,
        },
    },
    data () {
        return {
            tab: 'info',
            loading: false,
            starting: false,
            error: undefined,
            course: undefined,
            activeCourse: undefined,
            youtubeVideoUrl: undefined,
            description: undefined,
            redirectsLoading: false,
            preloadingVideo: false,
            tasksParams: undefined,
            loadingPrice: false,
            prices: undefined,
            hasBought: undefined,
            hasModules: false,
            isFreeCourse: false,
            subscription: undefined,
            showResultsButton: false,
        };
    },
    computed: {
        courseId () {
            return this.params.course_id;
        },
        user () {
            return this.$store.state.pages.user;
        },
        title () {
            const { title } = this.params;
            return title;
        },
        stars () {
            if (!this.activeCourse) { return 0; }
            return +this.activeCourse.stars + +this.activeCourse.extra_stars;
        },
        buttonCertificateVisible () {
            return this.activeCourse && (this.stars >= +this.course.min_stars_for_certificate);
        },
    },
    watch: {
        tab (v) {
            sessionStorage.setItem(`course-${this.courseId}-tab`, v);
        },
    },
    mounted () {
        this.load();
    },
    methods: {
        async load () {
            this.loading = true;
            this.pretask_text = undefined;
            this.description = undefined;
            this.course = undefined;
            this.tab = sessionStorage.getItem(`course-${this.courseId}-tab`) || 'info';
            this.isFreeCourse = false;
            this.activeCourse = undefined;

            const { user } = this.$store.state.pages;

            if (user) {
                this.showResultsButton = true;
                // Загрузить информацию о активности курса
                await this.$db.tasks.getUserCourse(user.id, this.courseId).then((c) => {
                    this.activeCourse = c;
                    const tab = this.$route.query.cert_course_id;
                    if (tab) {
                        this.tab = 'certificate';
                    }
                });
            }

            await this.$db.tasks.getCourses(`id = ${this.courseId}`).then(async (courses) => {
                const course = courses[0];
                this.course = course;
                this.redirectsLoading = true;
                if (course.description && course.description.includes('youtube')) {
                    this.preloadingVideo = true;
                }
                if (course.description) {
                    this.makeLinks(course.description, 'description');
                }
                this.redirectsLoading = false;
                this.tasksParams = {
                    course_id: this.courseId,
                    show_all_tasks: false,
                    hide_header: true,
                };
            });
            this.hasBought = undefined;
            await this.$db.users.getBoughtCourseInfo(this.courseId).then(async (b) => {
                this.hasBought = b;
                if (!b) {
                    await this.loadCoursePrice();
                }
            });

            this.hasModules = false;
            await queryBot(`select count(id) as cnt from modules where course_id = ${this.courseId}`).then((r) => {
                this.hasModules = r.data[0] && +r.data[0].cnt > 0;
            });
            this.tasksParams.tasksEnabled = this.hasBought !== undefined;
            this.loading = false;
        },
        loadSubscription (id) {
            this.$db.tasks.getSubscriptions(`id = ${id}`).then((subs) => {
                // eslint-disable-next-line prefer-destructuring
                this.subscription = subs[0];
            });
        },
        async makeLinks (text, tag) {
            text = await this.extractYoutubeVideo(text);
            const exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig;
            const text1 = text.replace(exp, "<a href='$1'>$1</a>");
            const exp2 = /(^|[^/])(www\.[\S]+(\b|$))/gim;
            text = text1.replace(exp2, '$1<a target="_blank" href="https://$2">$2</a>');
            text = text.replaceAll('\n', '<br/>');
            if (tag === 'pretask_text') {
                this.pretask_text = text;
            } else {
                this.description = text;
            }
        },
        async extractYoutubeVideo (text) {
            // TODO: - технический долг
            // вынести это в отдельный класс парсеров
            const urls = extractUrls(text);

            this.youtubeVideoUrl = undefined;
            if (urls && urls.length > 0) {
                for (let index = 0; index < urls.length; index += 1) {
                    let url = urls[index];
                    // eslint-disable-next-line no-continue
                    if (!url) { continue; }
                    // eslint-disable-next-line no-continue
                    if (this.youtubeVideoUrl) { continue; }

                    // text = text.replace(url, '');
                    let finalUrl;

                    const i = url.indexOf('\n');
                    if (i > 0) {
                        url = url.slice(0, i);
                    }

                    const data = new FormData();
                    data.append('url', url);
                    // eslint-disable-next-line no-await-in-loop,no-loop-func
                    await api.post('bypass_url.php', data).then((r) => {
                        finalUrl = r.data.url;
                        if (finalUrl && !this.youtubeVideoUrl) {
                            if (finalUrl.includes('youtube.com')) {
                                finalUrl = this.trimUrl(finalUrl);

                                if (finalUrl.includes('embed')) {
                                    this.youtubeVideoUrl = finalUrl;
                                } else {
                                    this.youtubeVideoUrl = this.makeYoutubeVideoEmbed(finalUrl);
                                }
                                this.preloadingVideo = false;
                                this.redirectsLoading = false;
                                text = text.replace(url, '');
                                /*
                                    const matchesFull = text.match(/(\(https?:\/\/[^ ]*)/);
                                    if (matchesFull && matchesFull.length > 0) {
                                        text = text.replaceAll(matchesFull[0], '');
                                        return text;
                                    }
                                     */
                            }
                        }
                    });
                }
            } else {
                this.redirectsLoading = false;
            }
            // this.preloadingVideo = false;
            return text;
        },
        makeYoutubeVideoEmbed (url) {
            // https://www.youtube.com/watch?v=4kHnM8ZT8qE&t=5s
            url = url.replaceAll('https://www.youtube.com/watch?', '');
            const urlParams = new URLSearchParams(url);
            const videoKey = urlParams.get('v');
            let timeStart = urlParams.get('t') || '0';
            timeStart = timeStart.replace('.', '');
            timeStart = timeStart.replace('s', '');
            url = `https://www.youtube.com/embed/${videoKey}?autoplay=0&fs=1&start=${timeStart}`;
            return url;
        },
        trimUrl (url) {
            // вырезать точки, запятые, вокслиц знак, вопрос, точка с запятой, разные кавычки, закрывающаяся скобка
            const chars = ['.', ',', '!', '?', ';', '"', '`', '\'', ')'];
            for (let i = 0; i < chars.length; i += 1) {
                const c = chars[i];
                if (url.slice(-1) === c) {
                    url = url.slice(0, -1);
                }
            }
            return url;
        },
        makeCert () {
            this.$pages.push({ to: 'cert2', title: `Удостоверение по курсу "${this.course.title}"`, params: { course_id: this.course.id, title: this.course.title } });
        },
        async loadCoursePrice () {
            this.loadingPrice = true;
            this.prices = undefined;
            await this.$db.tasks.getCoursePrices(this.courseId).then((prices) => {
                this.prices = prices;
                if (!prices || (prices && prices.length === 0)) {
                    this.hasBought = true;
                    this.isFreeCourse = true;
                }
                this.loadingPrice = false;
            });
        },
        buyCourse () {
            this.$pages.push({ to: 'buy-course', title: 'Покупка курса', params: { course_id: this.courseId, title: this.course.title } });
            // console.log('tariff:', tariff);
            // window.open('https://obr.so/project-activity/');
            /*
            this.$pages.push({
                to: 'buy-course', course_id: this.courseId, course_title: this.course.title, tariff,
            });
            */
        },
        openUrl (url) {
            window.open(url, '_blank');
        },
        splitText (text) {
            if (!text) {
                return undefined;
            }
            const items = text.split('\r\n');
            return items;
        },
        backClick (e) {
            const { user } = this;
            if (!user) {
                e.cancelBubble = true;
                this.$pages.push({ to: 'login' });
                return false;
            }
            return true;
        },
        /*
        start () {
            const { user } = this.$store.state.pages;
            if (!user) { return; }
            this.starting = true;
            if (this.$db.tasks.isCourseActive(this.courseId, user.id)) {
                const pageTasks = { to: 'tasks', title: this.course.title, course_id: this.courseId };
                this.$pages.back();
                this.$pages.push(pageTasks);
                return;
            }
            this.$db.tasks.startCourse(this.courseId, user.id).then((r) => {
                this.starting = false;
                if (r.data.id) {
                    const pageTasks = { to: 'tasks', title: this.course.title, course_id: this.courseId };
                    this.$pages.back();
                    this.$pages.push(pageTasks);
                }
            });
        },
        */
    },
};
</script>

<style scoped>

</style>
